<app-dossier eyebrow="Agence // Point de contact" reference="Accès restreint">
  <app-page-title
    title="Killer Party"
    lede="Une agence clandestine. Une cible. Une action discrète."
  />

  @if (latest(); as session) {
    <section class="card resume" aria-labelledby="resume-title">
      <img class="paperclip paperclip--small" src="/assets/paperclip.svg" alt="" />
      <div class="card__header">
        <h2 class="card__title" id="resume-title">Mission en cours</h2>
      </div>
      <p class="text-small">
        @if (session.codeName) {
          Agent {{ session.codeName }}, votre dossier vous attend.
        } @else {
          Votre dossier vous attend.
        }
      </p>
      <a
        class="button button--primary button--block"
        [routerLink]="['/missions', session.missionId]"
      >
        Reprendre ma mission <span class="button__arrow" aria-hidden="true">›</span>
      </a>
    </section>
  }

  <h2 class="section-label">Rejoindre une opération</h2>
  <form class="form" (submit)="open($event)" novalidate>
    <div class="field" [class.field--invalid]="error()">
      <label class="field__label" for="operation">Lien ou code de l'opération</label>
      <input
        #operation
        class="field__input"
        id="operation"
        type="text"
        autocomplete="off"
        placeholder="Collez le lien reçu"
        [attr.aria-invalid]="error() ? true : null"
        (input)="link.set(operation.value)"
      />
      @if (error(); as error) {
        <p class="field__error">{{ error }}</p>
      } @else {
        <p class="field__hint">
          Scannez le code QR de l'affiche de recrutement, ou collez le lien transmis par
          l'organisateur.
        </p>
      }
    </div>
    <button class="button button--secondary button--block" type="submit">
      Consulter le dossier
    </button>
  </form>

  <div class="note">
    <img class="paperclip paperclip--small" src="/assets/paperclip.svg" alt="" />
    <p>Vous organisez une opération ?</p>
    <p><a class="accent" routerLink="/operation-settings">Accès au quartier général</a></p>
  </div>
</app-dossier>
